module.exports = __webpack_public_path__ + "img/Logo_Journal_Le_Bien_Public_-_2022.12c9ef03.svg";